import merchantTileList from './merchantTileList';

export default merchantTileList;
